import { IconDown, Title, ButtonGroup } from "dash-styled"
import React, { FC } from "react"
import { UITaskModel } from "../../../../../../../../Models/API/TaskModel"
import { NextButton } from "../../../../../../../Common/Button/NextButton"
import { PrevButton } from "../../../../../../../Common/Button/PrevButton"
import { FlatButton } from "../../../../../../../Common/FlatButton/FlatButton"
import { TaskStatusPill } from "../../../Common/TaskStatusPill"
import { TaskAssigneeView } from "../TaskAssigneeView"

interface TaskDetailViewSubheaderProps {
    className?: string
    appID: string
    selectedTask?: UITaskModel
    totalTasks: number
    isJsonShown: boolean
    showFormatted: () => void
    showJson: () => void
    goBack: () => void
    onTaskChange: (taskNumber: number) => void
}

export const TaskDetailViewSubheader: FC<TaskDetailViewSubheaderProps> = ({
    className,
    appID,
    selectedTask,
    totalTasks,
    isJsonShown,
    showFormatted,
    showJson,
    goBack,
    onTaskChange
}) => {
    const taskNumber = selectedTask?.taskNumber

    return (
        <div
            className={`flex gap-4 justify-between ${className ?? ""}`}
            data-testid="detail-view-subheader"
        >
            <div
                data-testid="task-detail-view-go-back"
                className="flex w-0 flex-shrink-0 flex-grow items-center cursor-pointer"
                onClick={goBack}
            >
                <IconDown className="transform rotate-90 mr-1 text-smoke-800" />
                {taskNumber !== undefined && (
                    <Title
                        className="mb-0"
                        variant="heading2"
                        component="h1"
                        weight="semibold"
                    >
                        Task {taskNumber}
                    </Title>
                )}
            </div>
            {totalTasks > 1 && taskNumber !== undefined ? (
                <div
                    className="flex flex-shrink-0 items-center z-10"
                    data-testid="task-nav-section"
                >
                    <PrevButton
                        className={`mr-2 text-smoke-900 ${
                            taskNumber > 1 ? "opacity-100" : "opacity-0"
                        }`}
                        onClick={() => onTaskChange(taskNumber - 1)}
                        disabled={taskNumber <= 1}
                        size="xs"
                        testId="task-nav-prev-button"
                    />
                    <div
                        className="text-rhino-900"
                        data-testid="task-nav-indicator"
                    >
                        {taskNumber} of {totalTasks}
                    </div>
                    <NextButton
                        className={`ml-2 text-smoke-900 ${
                            taskNumber < totalTasks
                                ? "opacity-100"
                                : "opacity-0"
                        }`}
                        onClick={() => onTaskChange(taskNumber + 1)}
                        disabled={taskNumber >= totalTasks}
                        size="xs"
                        testId="task-nav-next-button"
                    />
                </div>
            ) : null}
            <div className="flex w-0 flex-grow items-center justify-end text-rhino-900">
                {selectedTask !== undefined ? (
                    <>
                        <TaskAssigneeView
                            className="truncate hidden xl:block"
                            appID={appID}
                            model={selectedTask}
                            tooltipPlacement="bottom"
                        />
                        <div className="flex items-center mx-2">
                            <TaskStatusPill
                                className="h-6"
                                size="sm"
                                status={selectedTask.status}
                                correct={selectedTask.correct}
                            />
                        </div>
                    </>
                ) : null}
                <ButtonGroup equalWidth={false}>
                    <FlatButton
                        onClick={showFormatted}
                        className={`${
                            isJsonShown ? "" : "bg-white"
                        } whitespace-no-wrap`}
                    >
                        Formatted
                    </FlatButton>
                    <FlatButton
                        onClick={showJson}
                        className={`${
                            isJsonShown ? "bg-white" : ""
                        } whitespace-no-wrap`}
                    >
                        JSON
                    </FlatButton>
                </ButtonGroup>
            </div>
        </div>
    )
}
